import {ReactNode} from 'react';
import {Button} from '../../components/Button';

interface LoginFormContainerProps {
  title: string;
  subtitle: string;
  showMobile: boolean;
  showBack: boolean;
  onBack: () => void;
  children: ReactNode;
}

/**
 * Container for the login/signup form section.
 * Handles mobile visibility and back button.
 */
export const LoginFormContainer = ({
  title,
  subtitle,
  showMobile,
  showBack,
  onBack,
  children,
}: LoginFormContainerProps) => {
  return (
    <div
      className={`flex flex-1 flex-col justify-center px-4 py-12 sm:px-6 lg:flex-none lg:px-20 xl:px-24 bg-surface ${
        !showMobile ? 'hidden lg:flex' : 'flex'
      }`}
    >
      <div className="mx-auto w-full max-w-sm lg:w-96 pt-24 md:pt-0">
        {showBack && (
          <Button
            variant="ghost"
            size="sm"
            onClick={onBack}
            className="lg:hidden mb-6 flex items-center"
            iconBefore={
              <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M15 19l-7-7 7-7"
                />
              </svg>
            }
          >
            Back
          </Button>
        )}
        <div className="text-center lg:text-left">
          <h2 className="text-3xl tracking-tight text-main">{title}</h2>
          <p className="mt-2 text-sm  text-muted">{subtitle}</p>
        </div>

        <div className="mt-10">{children}</div>
      </div>
    </div>
  );
};
